import('@splidejs/splide/dist/css/splide-core.min.css')
    .then(() => import('../../js/components/splide.js'));
